const GET_REASON = "GET_REASON";
const GET_REASON_SUCCESS = "GET_REASON_SUCCESS";
const GET_REASON_FAIL = "GET_REASON_FAIL";

const BASE_ENDPOINT = "/MasterData";
const initialValues = {
  loading: false,
  hasError: false,
  data:[]
};

const reason = (state = initialValues, action) => {
  switch (action.type) {
    case GET_REASON: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_REASON_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      };
    }

    case GET_REASON_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }
   
    default: {
      return state;
    }
  }
};

export const getReasons = () => {
  return {
    type: GET_REASON,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + "/CreditNote/Reason",
      },
    },
  };
};

export default reason;
